module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "m-b"
  }, [_c('fp-base-table', {
    ref: "table",
    attrs: {
      "size": _vm.size,
      "cols": _vm.colsForPages,
      "dataSource": _vm.pageDataSource.list,
      "selectType": _vm.selectType,
      "singleSelectTypeIcon": _vm.singleSelectTypeIcon,
      "singleSelectText": _vm.singleSelectText,
      "selectedArray": _vm.selectedArray,
      "keyPath": _vm.keyPath,
      "defaultSort": _vm.defaultSort
    },
    on: {
      "onSelect": _vm.handleSelect,
      "onSingleSelect": _vm.handleSingleSelect,
      "onCommandSelect": _vm.handleCommandSelect,
      "onSort": _vm.handleSort
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "right"
    }
  }, [(_vm.selectType == 'multiple' || _vm.selectType == 'both') ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedArray.length > 0),
      expression: "selectedArray.length>0"
    }],
    staticStyle: {
      "float": "left",
      "margin-left": "5px"
    }
  }, [_c('tag', {
    attrs: {
      "color": "success",
      "closable": ""
    },
    on: {
      "on-close": _vm.handleClear
    }
  }, [_vm._v(_vm._s(_vm.l('XUANZHONG')) + ":" + _vm._s(_vm.selectedArray.length) + " " + _vm._s(_vm.l('HANG')) + "\n      ")])], 1) : _vm._e(), _vm._v(" "), _c('page', {
    attrs: {
      "transfer": "",
      "show-total": "",
      "size": "small",
      "page-size-opts": [10, 20, 50, 100],
      "page-size": _vm.currentPageSize,
      "current": _vm.currentPage,
      "show-elevator": "",
      "show-sizer": "",
      "placement": "top",
      "total": _vm.pageDataSource.totalRow
    },
    on: {
      "on-page-size-change": _vm.handlePageSizeChange,
      "on-change": _vm.handlePageChange
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-47663fa8"}!./src/shared/libs/ClientFramework/packages/basicElement/table/PageTable.html
// module id = 925
// module chunks = 80